const API_ROUTES = {
  CALENDAR_DETAILS: "/calendars/details",
  CALENDAR_PERPETUAL_PDF: "/v2/calendars/perpetual",
  CALENDAR_PERPETUAL: "/calendars/perpetual",

};

export default API_ROUTES;
